import { mergeToNewObject } from '../../../util/helpers'
import { WALLET_CREATE } from '../../../constants/actions'

export const createProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case WALLET_CREATE.ON_PASSWORD_CHANGE:
      return mergeToNewObject(state, { password: payload })

    case WALLET_CREATE.ON_REPEAT_PASSWORD_CHANGE:
      return mergeToNewObject(state, { repeatPassword: payload })

    case WALLET_CREATE.ON_RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  password: '',
  repeatPassword: ''
}



// WEBPACK FOOTER //
// ./src/store/reducers/wallet/create.js